import React, { useCallback, useState } from 'react';
import { Mutation, Query } from 'react-apollo';
import Form from 'react-jsonschema-form';
import { Button } from 'reactstrap';

import i18n from '../../../../views/Pages/Login/i18n';
import { periodsQuery, startProcessMutation } from '../../../../queries/Queries';
import Loading from '../../../Loading';
import { createBillingProcessSchema } from '../../schemas/billingProcessSchema';

const CumulativeBillingForm = ({ processDefinitionId, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(
    async (startProcess, formData) => {
      setIsLoading(true);

      try {
        const response = await startProcess({
          variables: {
            processId: processDefinitionId,
            variables: [
              {
                name: 'C_Period_ID',
                type: 'string',
                value: formData.period,
              },
              {
                name: 'periodid',
                type: 'string',
                value: formData.period,
              },
            ],
          },
        });

        setIsLoading(false);

        if (response.data.startProcess) {
          onClose();
          // Show success message - TODO: Replace with proper notification system
          const alertParent = document.getElementById('alert');
          if (alertParent) {
            const alertContainer = document.createElement('div');
            alertContainer.className = 'alert alert-success';
            alertContainer.textContent = i18n.t('processes.successfulProcessStart');
            alertParent.appendChild(alertContainer);

            // Auto-remove after 5 seconds
            setTimeout(() => {
              if (alertParent.contains(alertContainer)) {
                alertParent.removeChild(alertContainer);
              }
            }, 5000);
          }
        }
      } catch (error) {
        setIsLoading(false);
        // Handle error appropriately
        // eslint-disable-next-line no-console
        console.error('Process start failed:', error);
      }
    },
    [processDefinitionId, onClose]
  );

  const loadingIcon = isLoading ? (
    <span>
      <i className='fa fa-circle-o-notch fa-spin'></i>{' '}
    </span>
  ) : null;

  return (
    <Mutation mutation={startProcessMutation} refetchQueries={[]}>
      {(startProcess) => (
        <Query query={periodsQuery}>
          {(result) => {
            if (result.loading) return <Loading />;
            if (result.error) return <div>{result.error}</div>;

            const { data } = result;
            const schema = createBillingProcessSchema(data.periods);

            return (
              <Form schema={schema} onSubmit={({ formData }) => handleSubmit(startProcess, formData)}>
                <div>
                  <Button type='submit' disabled={isLoading} color='primary'>
                    {loadingIcon}Start Process
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button type='button' onClick={onClose}>
                    Cancel
                  </Button>
                </div>
              </Form>
            );
          }}
        </Query>
      )}
    </Mutation>
  );
};

export default CumulativeBillingForm;
